export default {
	loading : false,
	privacy : '',
	terms   : '',
	warnings: '',
	locale  : null
}
